<template>
	<div>
		<response-action
			headTitle="response"
			fieldPrefix="resp_action"
			:dataSet="data"
			:actions="responseActions"
			:customerSupportDepartments="cs_departments"
			:apiParameterVariables="vars"
			@change="handleOnChangeRecord"
		></response-action>
		<button class="btn btn-primary" @click="updateResponseData">
			Save
		</button>
	</div>
</template>

<script>
import axios from 'axios';
import ResponseAction from '@/components/ResponseAction';
import Utilities from '@/directives/Autocomplete/Utilities'

	export default {
		components: {
			ResponseAction
		},
		data() {
			return {
				data: {},
				fixed_commands: {},
				responseActions: this.$store.state.command.response.actions,
				cs_departments: [],
				vars: [],
			}
		},
		methods: {
			set_customer_support_status() {
				return new Promise((resolve, reject) => {
					if (
						this.$store.state.user &&
						this.$store.state.user.hasOwnProperty('user_customer_support') &&
						this.$store.state.user.user_customer_support &&
						this.$store.state.user.user_customer_support.cs_status
					) {
						this.responseActions = this.responseActions.concat(
							[
								{
									label: 'connect to customer support',
									value: 'cs_connect',
								},
							],
							[
								{
									label: 'disconnect from customer support',
									value: 'cs_disconnect',
								},
							]
						)
						// get departments for cs.
						axios
							.get('/user/get_cs_departments')
							.then((res) => {
								if (res.data.status) {
									this.cs_departments = res.data.data
									var c_cs_departments = clone(this.cs_departments),
										cs
									while ((cs = c_cs_departments.pop())) {
										if (cs.id == this.resp_action_cs_connect_department) {
											c_cs_departments.push(cs)
											break
										}
									}
									if (!c_cs_departments.length) {
										this.resp_action_cs_connect_department = null
									}
									resolve('success')
								}
							})
							.catch((e) => {
								resolve('success')
							})
					} else {
						delete this.fixed_commands.cs_connect
						delete this.fixed_commands.cs_disconnect
						this.fixed_commands = {
							...this.fixed_commands,
						}
						resolve('success')
					}
					resolve('success')
				})
			},

			get_command_vars() {
				return new Promise((resolve, reject) => {
					axios
						.post('/command_var/get_all/' + this.command_id, {}, {})
						.then((res) => {
							if (res.data.status == 1) {
								this.vars = res.data.data
								// map id to names
								for (var _var in res.data.data) {
									this.vars_ids[res.data.data[_var].var_id] = res.data.data[_var].var_name
								}
								// Set Sender Info options
								this.vars_ids_with_sender_vars = {
									...this.vars_ids,
									...this.$store.state.sender_info,
								}
								this.setAutoCompeleteSchema()
							}
							resolve('success')
						})
						.catch((e) => resolve('error'))
				})
			},

			handleOnChangeRecord(data) {
				var record = Utilities.deepExtend(this.data, data, true)
				this.data = {...record}
			},

			updateResponseData() {
				this.$store.commit('setResponseDataProperty', this.data)

				this.$router.push(`/services/${this.serviceId}/commands/${this.commandId}/result/fallback`)
			},
		},
		created() {
			this.set_customer_support_status()
			this.get_command_vars()
		},
		computed: {
			serviceId() {
				return this.$route.params.service_id
			},
			commandId() {
				return this.$route.params.command_id
			},
		},
	}
</script>
